import { render, staticRenderFns } from "./CameraChildIntroductionNormal.vue?vue&type=template&id=399ab1c0&scoped=true&"
import script from "./CameraChildIntroductionNormal.vue?vue&type=script&lang=ts&"
export * from "./CameraChildIntroductionNormal.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildIntroductionNormal.vue?vue&type=style&index=0&id=399ab1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ab1c0",
  null
  
)

export default component.exports